import { Component,ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public collebraterList:any=[];
  public RefferalList:any=[];
  public RenewlList:any=[];
  public collebraterSerchList:any=[];
  public totalCount: number = 0;
  public rtotalCount: number = 0;
  public rrtotalCount:any=0;
  public p = 1;
  public rp = 1;
  public rrp = 1;

  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public loginDetail:any =[];
  public searchkey:any='';
  public viewClose:boolean=false;
  public userData:any=[];
  public Revenue:any=0;
  public term:boolean=false;
  public share:boolean=false;
  public rememberCheck:boolean=false;
  public communityCheck:boolean=false;
  public reavenueList:any=[];
  public revenues:any='';
  public termData:any= window.location.origin+'/termsandconditions';
  public vieswdata:boolean=false;

  refData = new FormGroup({
    firstname:new FormControl('',Validators.compose([
      Validators.required ])),
    lastname:new FormControl('',Validators.compose([
      Validators.required ])),    
    email:new FormControl('',Validators.compose([
      Validators.required, Validators.email  ])), 
    revenue:new FormControl('')
    // ,Validators.compose([
    //   Validators.required,Validators.min(1), Validators.max(75) ])),      
  })
  
  get f() { return this.refData.controls; } 
  
  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = getLocalJSON('grw_login');    
    if(this.loginDetail.user_role_type ==2){
      this.getRefreal(); 
      var js:any=[]
      for(let i=1;i<=75;i++){
        js.push(i);
      }
      this.reavenueList=js;
    }
    this.getCollebrtaor();
    // this.getRenewRequest();
   }

   ngOnInit(): void {
  }

  copy(txt:any) {
    navigator.clipboard.writeText(txt);
    this.service.successAlert('Code Copied');
  }

  getCollebrtaor(){
    const url = "/collaborators";
    var detail={
      'search':this.searchkey,
      'page':this.p
    } 
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self =this;
        if(this.loginDetail.user_role_type ==2){
          var js:any=[],total:any=0;
          response.data.record.filter((el:any)=>{
            if(el.collaborator_info.length !=0){
              el.name = el.collaborator_info[0].name;
              el.lname = el.collaborator_info[0].surname;
              el.creator = el.collaborator_info[0].full_name;
              el.logo = el.collaborator_info[0].profile_image;
              el.referral_code = el.collaborator_info[0].referral_code;           
              el.joining_date = self.service.ToDate1(el.createdAt);  
              el.c_id= el.collaborator_info[0]._id; 
              el.email = el.collaborator_info[0].email;
            }            
            el.term=el.term_condition; 
            el.share=el.term_condition;    
            el.reavenue=el.revenue_share;
            if(el.status=='Approved'){
              total=parseInt(el.revenue_share)+ total;
            }
          })
          this.collebraterList = response.data.record; 
          this.vieswdata=true;
          total=75-total;
          if(total==0){
            this.reavenueList.push('-');
          } else {
            for(let i=1;i<=total;i++){
              js.push(i);
            }
            this.reavenueList=js;
          }
        } else {
          response.data.record.filter((el:any)=>{
            if(el.status=='Pending'){
              el.term=false; 
              el.share=false; 
            } else {
              el.term=el.term_condition; 
              el.share=el.term_condition; 
            }
        
          })
          this.collebraterList = response.data.record;
          this.vieswdata=true;
        }
        this.totalCount = response.data.total;
       
      } else {
        this.collebraterList =[];
        this.totalCount = 0;
        this.vieswdata=true;
      }
    }), (error) => { this.loading =false; });
  }

  getRenewRequest(){
    const url = '/renew-collaboration-request-list' ; 
    this.service.PostApis({'page':this.rrp},url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.RenewlList = response.data.record;
        this.rrtotalCount = response.data.total;
      } else {
        this.RenewlList =[];
        this.rrtotalCount = 0;

      }
    }), (error) => { this.loading =false; });
  }

  getRefreal(){
    const url = '/referral-request' ; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.RefferalList = response.data.record;
        this.rtotalCount = response.data.total;
      } else {
        this.RefferalList =[];
        this.rtotalCount = 0;

      }
    }), (error) => { this.loading =false; });
  }

  Onsubmit(){
    this.submitted = true;  
    let userdetail = this.refData;   
        if(userdetail.valid){
          this.loading = true; 
          var url="/send-referral-request";
          var detail:any={
            "first_name": userdetail.value.firstname,
            "last_name": userdetail.value.lastname, 
            "email": (userdetail.value.email)?.toLowerCase(),   
            "referral_user": this.communityCheck        
          } 
          if(this.revenues !=''){
            detail.revenue_share= 0;
          }
          this.service.PostApis(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){ 
              this.close(2);
              this.getRefreal();
              this.refData.reset();
              this.communityCheck=false;
              this.submitted = false
              this.service.successAlert(response.message);
              // localStorage.setItem('grw_loginData',JSON.stringify({"email": userdetail.value.email,"password": userdetail.value.password})); 
              this.loading = false;
            } else {
              this.loading = false;
              this.service.dangerAlert(response.message);
            }
          }), (error:any) => {
          });
        } else{
        }
  }

  close(type:any){
    if(type ==1){
      $('#qr_code_download').modal('toggle');
    } else if(type ==3){
      $('#qr_code_download').modal('toggle');
      this.printPopUp();
    } else if(type ==2){
      $('#Invite_People_Request').modal('toggle');
    } else if(type ==4){
      $('#Invite_revenue_Request').modal('toggle');
    } else {
      $('#Invite_revenue_Request').modal('toggle');
      // if(this.term){
      //   $('#Invite_revenue_Request').modal('toggle');
      // } else {
      //   this.service.dangerAlert("Please confirm T&C's'");
      // }
    }
   
  }

  printPopUp() {
    const imgSrc:any = document.getElementById('qr_code');
    const body:any = document.getElementsByTagName('body')[0];
    let downloadAnchor = document.createElement('a');
        downloadAnchor.setAttribute('id', 'download_qr');
        downloadAnchor.setAttribute('download','download' );
        downloadAnchor.setAttribute('href', imgSrc.src);
        downloadAnchor.innerHTML = 'download';
        body.appendChild(downloadAnchor);
        const anchor:any = document.getElementById('download_qr');
        anchor.click();
        anchor.remove();  
      }

    searchText(type:any){
      if(type==1){
        this.viewClose=true;
      } else {
        this.viewClose= false;
        this.searchkey='';
      }
      this.p=1;
      this.getCollebrtaorSearch();
    }

    getCollebrtaorSearch(){
      this.loading=true;
      this.collebraterSerchList=[];
      const url = "/collaborators-search";
      var detail={
        'search':this.searchkey,
        'page':this.p
      } 
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1) { 
          this.totalCount = response.data.total;
          this.collebraterSerchList = response.data.record;
          this.loading =false;
        } else {
          this.collebraterSerchList =[];
          this.totalCount = 0;
          this.loading =false;
        }
      }), (error) => { this.loading =false; });
    }

    sendRequest(id:any){
      if( (this.Revenue !='' && (this.rememberCheck || this.term)) || !this.term){
        this.loading=true;
        var url="/send-request-for-creator";
        var detail:any={      
          "requestId": id,
          "revenue": this.Revenue,
          "term_condition": this.rememberCheck
        }
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1) { 
            this.loading=false;
            this.close(4);
            this.Revenue=0;
            this.getCollebrtaor();
            this.service.successAlert(response.message);
          } else {
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }))
      } else {
        if(!this.rememberCheck || !this.term){
          this.service.dangerAlert("Please confirm T&C's'");
        } else {
          this.service.dangerAlert('Please add revenue percentage');
        }
        
      }
      
    }

    acceptRequest(id:any,status:any){
      if( (status=='Approved' && this.term) || status=='Denied'){
        this.loading=true;
        var url="/accept-organization-request";
        var detail:any={
          "request_id": id,
          "status": status,
          "term_condition": this.term
        }
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success){
            this.getCollebrtaor();
            this.loading=false;
          } else {
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }))
      } else {
        this.service.dangerAlert("Please confirm T&C's'");
      }
   
    }
    
    addrequest(id:any){
      this.loading=true;
      var url="/added-on-record";
      var detail:any={      
        "requestId": id,
      }
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1) { 
          this.loading=false;
          this.service.successAlert(response.message);
          this.searchkey='';
          this.collebraterSerchList=[];
          this.getCollebrtaor();
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }))
    }

    getValue(event:any ,type:any){
      var ss:any=false;
      if(event.target.checked){
        ss=true;
      } else {
        ss=false;
        this.Revenue=0;
      } 
      this.term=ss;
      // this.share =ss;
      this.rememberCheck =ss;
      if(ss==true && type==1){
        $('#Invite_revenue_Request').modal('toggle');
      }
      if(type==1){
        this.term=ss;
        this.userData.term=ss;
      } else {
        this.share =ss;
        this.userData.share=ss;
      }
    }

    RemoveRequest(id:any){
        this.loading=true;
        var url="/delete-added-collaborator";
        var detail:any={      
          "creatorId": id,
        }
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1) { 
            this.loading=false;
            // this.close(4);
            this.getCollebrtaor();
          } else {
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }))
    
      
    }

    setREvenue(event:any){
      this.Revenue=event.target.value;
    }

    pagechanged(type:any,p:any){
      if(type==1){
        this.p=p;
        this.getCollebrtaor();
      } else if(type==2) {
        this.rp=p;
        this.getRefreal();
      } else {
        this.rrp=p;
        this.getRenewRequest();
      }
    }

    redirect(id:any,type:any){
      if(type==1){
      localStorage.setItem('grw_ids',id);
      this.router.navigate(['/share-detail']);
      } else {
      localStorage.setItem('grw_re','1');
      this.router.navigate(['/singles']);

      }
    }

    clear(id:any){
      var url='/collaborator-request-delete?request_id='+id;
      this.service.DeleteApi(url).subscribe(((response:any)=>{
        if(response.success ==1) { 
          this.loading=false;
          this.service.successAlert(response.message);
          this.searchkey='';
          this.collebraterSerchList=[];
          this.getCollebrtaor();
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }))
    }

    RenewcancelRequest(type:any,id:any){
      var url='';
      if (type==1){
        url="/cancel-collaboration/";
      } else {
        url="/renew-collaboration-request";
      }
      var detail:any={      
        "request_id": id,
      }
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1) { 
          this.loading=false;
          // this.close(4);
          this.getCollebrtaor();
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }))
    }

    RenewApproveRejectRequest(type:any,id:any){
      var url='/update-renew-request-status';
      var detail:any={      
        "request_id": id,
      }
      if (type==1){
       detail.status='Approved';
      } else {
        detail.status='Reject';
      }
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1) { 
          this.loading=false;
          // this.close(4);
          this.getCollebrtaor();
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }))
    }
}
